import React, { createRef } from 'react';
import Modal from 'react-responsive-modal';

import { Realm } from '../../util/realm/realm';
import { 
	Instance,
	DATATYPE_STRING,
	DATATYPE_ENUM,
	DATATYPE_INTEGER,
	DATATYPE_DECIMAL,
	DATATYPE_DATETIME,
	DATATYPE_REFERENCE

} from '../../util/realm/instance';
import Label from './Label';
import ModalDialog, {MODAL_STATE_FORM_READY, MODAL_STATE_PERFORM_REQUEST, } from '../modal/ModalDialog';

import { getActualRealm } from './utilPlain';
import { getCurrentResource, getDefinedValue, getDefinedItem } from '../../util/tools';
import { 
	performApiRequest,
	QUERY_GETENTITYFORM_API_URL, 
	QUERY_GETENTITYPAGE_API_URL, 
} from '../../util/restapi';

import acceptIcon from '../../assets/icons/png24x24/Accept.png';
import spinnerIcon from '../../assets/icons/Spin124px.gif';
import firstPageIcon from '../../assets/icons/png24x24/go-first.png';
import lastPageIcon from '../../assets/icons/png24x24/go-last.png';
import prevPageIcon from '../../assets/icons/png24x24/Left.png';
import nextPageIcon from '../../assets/icons/png24x24/Right.png';
import addIcon from '../../assets/icons/png24x24/Add.png';
import editIcon from '../../assets/icons/png24x24/edit.png';
import deleteIcon from '../../assets/icons/png24x24/Delete.png';

import signPlusIcon from '../../assets/icons/sign_plus_green.png';
import signCheckIcon from '../../assets/icons/sign_check_blue.png';
import signCrossIcon from '../../assets/icons/sign_cross.png';

const FORM_STATE_INIT = 'fsInit';
const FORM_STATE_READY = 'fsReady';
const FORM_STATE_POPULATE = 'fsPopulate';

class FieldList_TableEntity extends React.Component {

	isFormValid = false;
	invalidFormResponse = null;
	isDataValid = false;
	invalidPopulateResponse = null;

	realm = null;
	form = null;
	instanceModel = null;
	resource = null;

	rowCount = null;	
	pageCount = null;
	rows = [];
	
	beanForEdit = null;
	listIdForDelete = [];
	
	/*
		formId
		instance
		readOnly
		table
			columns [{
				columnId
				refNodes
				title
				tooltip
				styles
					divMainLabelHeader
					tdHeader
					tdData
					dataComponent
			}]
			border
		styles
			divMain
			table
			thead
			trHeader
		modal
			title
			createModalForm
			getModalFormRef
	*/
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.plain.FieldList_TableEntity;
		this.refDeleteModalDialog = React.createRef();
		this.refDeleteModal = createRef();
		this.state = {
			formState: FORM_STATE_INIT,
			currentPage: 1,
			dirtyCount: 0,
			isEditModalOpen: false,
			isDeleteModalOpen: false,
		}
	}
	componentDidMount = async () => {
		let response = await getActualRealm();
		if( ! response.success ) {
			this.isFormValid = false;
			this.invalidFormResponse = response;
			this.setState( { formState: FORM_STATE_READY} );
			return;
		}
		this.realm = new Realm(response.data);
		
		const request = {
			formId: this.props.formId
		};
		response = await performApiRequest( QUERY_GETENTITYFORM_API_URL, request );
		if( ! response.success ) {
			this.isFormValid = false;
			this.invalidFormResponse = response;
			this.setState( { formState: FORM_STATE_READY} );
			return;
		}

		this.isFormValid = true;
		this.form = response.data;
		this.instanceModel = this.realm.getInstanceModel(this.form.classId);
		
		await this.populatePage();

		this.setState( { formState: FORM_STATE_READY} );
	}

	closeEditModal = () => {
		this.setState({ isEditModalOpen: false });	
	}
	openDeleteModal = () => {
		let listId = [];
		for(let row of this.rows) {
			if( row.marked ) {
				listId.push( row.bean.id )
			}
		}
		if( listId.length > 0 ) {
			this.refDeleteModalDialog.current.openModal();
		}
	}
	
	firstPage = () => {
		if( this.state.currentPage == 1 )
			return;
		this.setState({currentPage: 1}, this.populatePage);
	}
	prevPage = () => {
		if( this.state.currentPage == 1 )
			return;
		this.setState({currentPage: this.state.currentPage-1}, this.populatePage);
	}
	nextPage = () => {
		if( this.state.currentPage >= this.pageCount )
			return;
		this.setState({formState: FORM_STATE_POPULATE, currentPage: this.state.currentPage+1}, this.populatePage);
	}
	lastPage = () => {
		if( this.state.currentPage >= this.pageCount )
			return;
		this.setState({formState: FORM_STATE_POPULATE, currentPage: this.pageCount}, this.populatePage);
	}
	populatePage = async () => {
		this.setState( { formState: FORM_STATE_POPULATE} );
		
		let query = {
			queryId: this.form.formId,
			page: this.state.currentPage,
			pageSize: 20,
			getTotalCount: this.rowCount == null,
			masterId: this.props.instance.id,
		}
		let response = await performApiRequest( QUERY_GETENTITYPAGE_API_URL, query );
		if( ! response.success ) {
			this.isDataValid = false;
			this.invalidPopulateResponse = response;
			this.setState( { formState: FORM_STATE_READY} );
			return;
		}
		
		if( this.rowCount == null ) {
			this.rowCount = response.data.totalCount;
			this.pageCount = response.data.pageCount;
		}
		this.rows = [];
		for(let obj of response.data.objects) {
			this.rows.push( {
				marked: false, bean: obj, 
				isNew: false, isEdited: false, isDeleted: false,
				instance: new Instance(this.instanceModel, obj)
			} );
		}
		
		this.setState( { formState: FORM_STATE_READY} );
	}

	markRow = (e, rowIndex) => {
		this.rows[rowIndex].marked = e.target.checked;
		this.setState({dirtyCount: this.state.dirtyCount+1});
	}
	markAllRows = () => {
		let hasNotMarked = false;
		for(let row of this.rows) {
			if( ! row.isDeleted &&  ! row.marked ) {
				hasNotMarked = true;
				break;
			}
		}
		let newMarkedValue = hasNotMarked;
		for(let row of this.rows) {
			if( ! row.isDeleted )
				row.marked = newMarkedValue;
		}
		this.setState({dirtyCount: this.state.dirtyCount+1});
	}
	
	addRow = () => {
		this.indexForEdit = -1;
		this.beanForEdit = null;
		this.setState({isEditModalOpen: true});
	}
	edit = () => {
		let indexMarked = null;
		for(let index=0; index < this.rows.length; index++) {
			let row = this.rows[index];
			if( row.marked ) {
				row.marked = false;
				indexMarked = index;
				break;
			}
		}
		if( indexMarked != null ) {
			this.indexForEdit = indexMarked;
			this.beanForEdit = this.rows[indexMarked].bean;
			this.setState({isEditModalOpen: true});
		} else {
			this.indexForEdit = -1;
			this.beanForEdit = null;
		}
	}
	updateRow = (bean, rowIndex) => {
		if( rowIndex < 0 ) {
			this.rows.unshift({
				marked: false, bean: bean, 
				isNew: true, isEdited: false, isDeleted: false,
				instance: new Instance(this.instanceModel, bean)
			});
		} else {
			let row = this.rows[rowIndex];
			row.marked = false; 
			row.bean = bean;
			row.instance = new Instance(this.instanceModel, bean);
			row.isEdited = true;
		}
		this.setState({dirtyCount: this.state.dirtyCount + 1});
	}

	createModalForm	= () => {
		return (<div>Form is not defined</div>)
	}
	render() {
		let styles = getDefinedValue( this.props.styles, {} );
		let border = getDefinedItem( this.props, ['table', 'border'], '1');
		
		if( this.state.formState == FORM_STATE_INIT ) {
			return (
				<div style={getDefinedValue(styles.divMain, {})}>
					<ControlPanel holder={this} />
					<div style={{marginTop: '10px', textAlign: 'center'}}>
						<img src={spinnerIcon} />
					</div>
				</div>
			);
		}
		if( this.state.formState == FORM_STATE_POPULATE ) {
			return (
				<div style={getDefinedValue(styles.divMain, {})}>
					<ControlPanel holder={this} />
					<div style={{marginTop: '10px', textAlign: 'center'}}>
						<img src={spinnerIcon} />
					</div>
				</div>
			);
		}
		
		let rowsHtml = this.rows.map((row, rowIndex) => {
			let rowIcon = null;
			let tdCheckBoxMarkedHtml = (
				<td style={{textAlign: 'center'}}>
					<input type="checkbox" onChange={ (e)=> {this.markRow(e, rowIndex)}} checked={row.marked} />
				</td>
			);
			let iconTitle = '';
			if( row.isDeleted ) {
				rowIcon = signCrossIcon;
				tdCheckBoxMarkedHtml = <td>&nbsp;</td>
				iconTitle = this.resource.iconSignCross;
			} else if( row.isNew ) {
				rowIcon = signPlusIcon;
				iconTitle = this.resource.iconSignPlus;
			} else if( row.isEdited ) {
				rowIcon = signCheckIcon;
				iconTitle = this.resource.iconSignCheck;
			}
			let cellsHtml = this.props.table.columns.map((col, index) => {
				let field = row.instance.getField(col.columnId);
				let value = field.value;
				let fieldModel = field.model
				let colStyles = getDefinedValue(col.styles, {});
				
				let component = null;
				if( component == null ) {
					
					let componentStyle = getDefinedValue(colStyles.dataComponent, {});
					if( fieldModel.dataType == DATATYPE_STRING ) {
						let value = field.value;
						if( fieldModel.isDate )
							component = <div style={componentStyle}>{value}</div>
						else
							component = <div style={componentStyle}>{value}</div>
					}
					if( fieldModel.dataType == DATATYPE_ENUM ) {
						let enumeration = this.realm.getEnumeration(fieldModel.enumerationId);
						let text = this.realm.getEnumerationItemText(enumeration, value);
						component = <div style={componentStyle}>{text}</div>
					}
					if( fieldModel.dataType == DATATYPE_INTEGER ) {
						component = <div style={componentStyle}>{value}</div>
					}
					if( fieldModel.dataType == DATATYPE_DECIMAL ) {
						component = <div style={componentStyle}>{value}</div>
					}
					if( fieldModel.dataType == DATATYPE_DATETIME ) {
						component = <div style={componentStyle}>{value}</div>
					}
					if( fieldModel.dataType == DATATYPE_REFERENCE ) {
						component = <div style={componentStyle}>{value.card}</div>
					}
				}

				
				let tdCellStyle = Object.assign( {}, getDefinedItem(col, ['styles', 'tdData'], {}) ); 
				if( row.isDeleted )
					tdCellStyle.color = 'rgb(170,170,170)';
				return (
					<td key={col.columnId} style={tdCellStyle}>
						{component}
					</td>
				)
			});
			
			let trCardHtml = null;
			if( this.props.columnCard ) {
				let colSpan = this.props.table.columns.length + 2;
				let tdCellStyle = Object.assign( {}, getDefinedItem(this.props.columnCard, ['styles', 'tdData'], {}) ); 
				if( row.isDeleted )
					tdCellStyle.color = 'rgb(170,170,170)';
				trCardHtml = (
					<tr key={'card' + rowIndex} style={{background: 'white'}}>
						<Cell table={this} row={row} columnCard={this.props.columnCard} colSpan={colSpan} />
					</tr>
				);
			}

			return (
				<React.Fragment>
					{trCardHtml}
					<tr key={rowIndex} >
						{tdCheckBoxMarkedHtml}
						<td style={{textAlign: 'center'}}>
							<img src={rowIcon} title={iconTitle} />
						</td>
						{cellsHtml}
					</tr>
				</React.Fragment>
			)
		});
		
		let modalEditHtml = null;
		if( this.state.isEditModalOpen ) {
			let modalTitle = getDefinedItem(this.props, ['modal', 'title'], 'Title');
			let createModalForm = getDefinedItem(this.props, ['modal', 'createModalForm'], this.createModalForm);
			modalEditHtml = (
				<Modal 
					open={this.state.isEditModalOpen} onClose={this.closeEditModal} center 
					styles={styleEditModal}
					closeOnOverlayClick={false} animationDuration={1}
				>
					<div>
						<div style={{fontSize: '16pt', textAlign: 'center', padding: '10px', borderRadius: '21px 21px 0 0', backgroundColor: '#F0F0F0'}}>
							{modalTitle}
						</div>
						{createModalForm(this, this.indexForEdit, this.beanForEdit)}
					</div>
				</Modal>
			);
		}
		return (
			<div style={getDefinedValue(styles.divMain, {})}>
				<ControlPanel holder={this} />
				<table border={border} style={getDefinedValue(styles.table, {})}>
					<TableHeader holder={this} styles={styles} />
					<tbody>
						{rowsHtml}
					</tbody>
				</table>
				{modalEditHtml}
				<DeleteModalDialog ref={this.refDeleteModalDialog} holder={this} />
			</div>
		);
	}
}

function Cell(props) {
	let table = props.table;
	let row = props.row;
	let columnCard = props.columnCard;
	let colSpan = getDefinedValue(props.colSpan, 1);
	
	let field = row.instance.getField(columnCard.columnId);
	let value = field.value;
	let fieldModel = field.model
	let colStyles = getDefinedValue(columnCard.styles, {});
	
	let component = null;
	let componentStyle = getDefinedValue(colStyles.dataComponent, {});

	if( fieldModel.dataType == DATATYPE_STRING ) {
		let value = field.value;
		if( fieldModel.isDate )
			component = <div style={componentStyle}>{value}</div>
		else
			component = <div style={componentStyle}>{value}</div>
	}
	if( fieldModel.dataType == DATATYPE_ENUM ) {
		let enumeration = table.realm.getEnumeration(fieldModel.enumerationId);
		let text = table.realm.getEnumerationItemText(enumeration, value);
		component = <div style={componentStyle}>{text}</div>
	}
	if( fieldModel.dataType == DATATYPE_INTEGER ) {
		component = <div style={componentStyle}>{value}</div>
	}
	if( fieldModel.dataType == DATATYPE_DECIMAL ) {
		component = <div style={componentStyle}>{value}</div>
	}
	if( fieldModel.dataType == DATATYPE_DATETIME ) {
		component = <div style={componentStyle}>{value}</div>
	}
	if( fieldModel.dataType == DATATYPE_REFERENCE ) {
		let valueHtml = null;
		if( value != null && value.id != null ) {
			let objectRefNode = null;
			for(let item of columnCard.refNodes) {
				if( item.classId == '*' || item.classId == value.className ) {
					objectRefNode = item;
					break;
				}
			}
			if( objectRefNode == null ) {
				valueHtml = (<span>{value.card}</span>);
			} else {
				if( row.isDeleted ) {
					valueHtml = (<span style={{color: 'rgb(170,170,170)'}}>{value.card}</span>);
				} else {
					let url = objectRefNode.plainFormPath + '/' + value.id;
					valueHtml = (<a href={url}>{value.card}</a>);
				}
			}
		} else {
			valueHtml = <span style={{fontWeight: 'bold', fontStyle: 'italic'}}>{table.resource.messageNotDefined}</span>;
		}
		component = <div style={componentStyle}>{valueHtml}</div>
	}
	
	let tdCellStyle = Object.assign( {}, getDefinedItem(columnCard, ['styles', 'tdData'], {}) ); 
	if( row.isDeleted )
		tdCellStyle.color = 'rgb(170,170,170)';
	return (
		<td key={columnCard.columnId} style={tdCellStyle} colspan={colSpan}>
			{component}
		</td>
	)
}

function TableHeader(props) {
	let holder = props.holder;
	let styles = props.styles;
	let instance = holder.props.instance;
	let instanceModel = holder.instanceModel;
	if( instanceModel == null ) {
		return (<thead/>)
	}
	let headerCellsHtml = holder.props.table.columns.map((col) => {
		let fieldModel = instance.getSubfieldModel(instanceModel, col.columnId);
		let title = col.title;
		if( ! title ) {
			if( fieldModel == null )
				title = col.columnId;
			else {
				title = fieldModel.shortTitle;
				if( ! title )
					title = fieldModel.title;
			}
		}
		let tooltip = col.tooltip;
		if( ! tooltip && fieldModel != null )
			tooltip = fieldModel.description;
		let labelStyle = Object.assign( 
			{color: 'black', fontWeight: 'bold', fontStyle: 'normal'}, 
			getDefinedItem(col, ['styles', 'divMainLabelHeader'], {}) ); 
		let component = <Label title={title} tooltip={tooltip} styles={{ divMain: labelStyle}} />
		let tdHeaderStyle = Object.assign(
			{textAlign: 'center'},
			getDefinedItem(col, ['styles', 'tdHeader'], {}) 
		); 
		return (
			<td key={col.columnId} style={tdHeaderStyle}>
				{component}
			</td>
		)
	});
	
	return (
		<thead style={getDefinedValue(styles.thead, {})}>
			<tr style={getDefinedValue(styles.trHeader, {})}>
				<td key={'colMarked'} onClick={holder.markAllRows} style={{textAlign: 'center'}}>
					<img src={acceptIcon}/>
				</td>
				<td>&nbsp;</td>
				{headerCellsHtml}
			</tr>
		</thead>
	)
}

function ControlPanel(props) {
	let holder = props.holder;
	let res = holder.resource
	let readOnly = holder.props.readOnly;
	return (
		<div style={{display: 'flex', padding: '10px 0 10px 0'}}>
			<button type='button' style={{width: '40px', height: '30px', marginRight: '10px'}} disabled={false}
				onClick={props.holder.firstPage} title={res.buttonFirstPage}
			>
				<img src={firstPageIcon} />
			</button>
			<button type='button' style={{width: '40px', height: '30px', marginRight: '10px'}} disabled={false}
				onClick={props.holder.prevPage} title={res.buttonPrevPage}
			>
				<img src={prevPageIcon} />
			</button>
			<button type='button' style={{width: '40px', height: '30px', marginRight: '10px'}} disabled={false}
				onClick={props.holder.nextPage} title={res.buttonNextPage}
			>
				<img src={nextPageIcon} />
			</button>
			<button type='button' style={{width: '40px', height: '30px', marginRight: '10px'}} disabled={false}
				onClick={props.holder.lastPage} title={res.buttonLastPage}
			>
				<img src={lastPageIcon} />
			</button>

			<button type='button' style={{width: '40px', height: '30px', marginLeft: '30px', marginRight: '10px'}} 
				disabled={readOnly} onClick={props.holder.addRow} title={res.buttonAddRow}
			>
				<img src={addIcon} />
			</button>
			<button type='button' style={{width: '40px', height: '30px', marginRight: '10px'}} 
				disabled={readOnly} onClick={props.holder.edit} title={res.buttonEditRow}
			>
				<img src={editIcon} />
			</button>
			<button type='button' style={{width: '40px', height: '30px', marginRight: '10px'}} 
				disabled={readOnly} onClick={props.holder.openDeleteModal} title={res.buttonDeleteRows}
			>
				<img src={deleteIcon} />
			</button>
			
			
			<div><InfoPanel holder={props.holder} /></div>
		</div>
	);
}

function InfoPanel(props) {
	let info = " ";  
	info += props.holder.resource.labelPageNum + ": ";
	info += props.holder.state.currentPage + " / " + props.holder.pageCount + " ";
	info += props.holder.resource.labelRecordCount + ": " + props.holder.rowCount;
	return (
		<div style={{marginLeft: '100px'}}>
			{info}
		</div>		
	); 
}

class DeleteModalDialog extends ModalDialog {

	constructor(props) {
		super(props);
		let holder = props.holder;
		let res = holder.resource;

		this.title = res.titleDeleteModal;
		this.buttonOkText = res.buttonYes;
		this.buttonCancelText = res.buttonNo;
		this.showTryAgainButton = false;
	}
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}
	getStyleBody() {
		let style = super.getStyleBody();
		style.divButtons.marginRight = '0';
		style.divButtons.marginBottom = '20px';
		style.divButtons.textAlign = 'center';
		return style;
	}
	async performRequest() {
		let holder = this.props.holder;
		let listId = [];
		for(let row of holder.rows) {
			if( row.marked ) {
				listId.push( row.bean.id )
			}
		}
		let response = await holder.props.deleteMarkedRows( listId );
		if( response.success ) {
			for(let row of holder.rows) {
				if( row.marked ) {
					row.isDeleted = true;
					row.marked = false;
				}
			}
			holder.setState({dirtyCount: holder.state.dirtyCount+1})
		}
		return response;
	}
	
	renderForm() {
		let res = this.props.holder.resource;
		let msgHtml = null;
		if( this.state.modalState == MODAL_STATE_FORM_READY ) {
			msgHtml = (
				<div style={{fontSize: '16pt'}}>
					{res.msgConfirmDelete}
				</div>
			);
		} else if( this.state.modalState == MODAL_STATE_PERFORM_REQUEST ) {
			msgHtml = (
				<div style={{fontSize: '16pt'}}>
					{res.msgDeleting}
				</div>
			);
		}
		return (
			<div style={{textAlign: 'center', margin: '30px 0 30px 0'}} >
				{msgHtml}
			</div>
		)
	}
}

const styleEditModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '1400px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

export default FieldList_TableEntity;
